import { request } from '@/utils/request'
//培训班集合
export function getTrainSingup(pageNo, pageSize) {
    return request({
        url: '/api/v1/course/courseInfo/getTrainSingup',
        method: 'get',
        params: {
            pageNo,
            pageSize
        }
    });
}

//培训班详情
export function getTrainDetail(sessionId,trainSignupId) {
    return request({
        url: `/api/v1/course/courseInfo/getCategory;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            trainSignupId
        }
    });
}

//获取版训班对应的课程
export function getCategoryCourse(sessionId,pageNo, pageSize, trainSignupId, name = '', finishStatus = '') {
    return request({
        url: `/api/v1/course/courseInfo/getCategoryCourse;JSESSIONID=${sessionId}`,
        method: 'post',
        data: {
            pageNo,
            pageSize,
            trainSignupId,//培训报名id
            name,//课程名称 '' 是全部
            finishStatus,//课程学习状态 '' 是全部 '0' 已完成 '1'未完成 '2'未学习
        }
    });
}

//获取培训班学生信息
export function getTrainStudents(sessionId,trainSignupId, pageNo, pageSize,) {
    return request({
        url: `/api/v1/course/courseInfo/getCategoryMember;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            trainSignupId,
            pageNo,
            pageSize,
        }
    });
}


//获取培训班支付详情
export function getCategoryPayInfo(sessionId,trainSignupId) {
    return request({
        url: `/api/v1/course/courseInfo/categoryPayInfo;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            trainSignupId
        }
    });
}

//培训班下单
export function orderPay(sessionId,businessId, businessType, payMode, invoiceInfo) {
    return request({
        url: `/api/v1/otorder/orderInfo/transactions;JSESSIONID=${sessionId}?__ajax=true`,
        method: 'post',
        data: {
            businessId,//培训报名id
            businessType,//类型 '0' 培训班 '2'考试
            payMode,//支付类型 3 银联  4 微信
            invoiceInfo//发票信息
        }
    });
}

//获取课程详情
export function getCourseDetail(sessionId,trainSignupId, courseId, id) {
    return request({
        url: `/api/v1/course/courseInfo/getVideoByCourseId;JSESSIONID=${sessionId}?__ajax=true`,
        method: 'post',
        data: {
            trainSignupId,//培训报名id
            courseId,//课程id
            id,//视频章节id '' 点击课程进入学习详情 id有值 个人中心 -- 继续学习进入学习详情
        }
    });
}

//保存视频观看事件 -- 学习进度
export function saveVideoTime(sessionId,trainSignupId,courseId, videoId, playPosition) {
    return request({
        url: `/api/v1/course/courseInfo/saveStudyRate;JSESSIONID=${sessionId}`,
        method: 'post',
        data: {
            trainSignupId,
            courseId,
            videoId,
            playPosition
        }
    });
}
//获取培训班通知公告列表
export function getCategoryNotifyList(sessionId,trainSignupId,pageNo,pageSize) {
    return request({
        url: `/api/v1/course/courseInfo/getCategoryNotify;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            trainSignupId,
            pageNo,
            pageSize
        }
    });
}

//获取培训班通知公告详情
export function getCategoryNotifyDetail(sessionId,notifyId) {
    return request({
        url: `/api/v1/course/courseInfo/getCategoryNotifyDetail;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            notifyId
        }
    });
}

//腾讯云获取视频详情
export function getTxyVideo(sessionId,videoId) {
    return request({
        url: `/api/v1/course/courseInfo/getTxyData;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            videoId
        }
    });
}


//校验学员学习资格
export function checkGxkSignup(sessionId,categoryInfoId) {
    return request({
        url: `/api/v1/ctMember/member/checkGxkSignup;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            categoryInfoId
        }
    });
}
